import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-help-filled",
  "use": "rt-base-circle-help-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-help-filled\"><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 688c-25.7 0-46.5-20.8-46.5-46.5S486.3 659 512 659s46.5 20.8 46.5 46.5S537.7 752 512 752z m51.9-188.4c-8.3 2.6-14.1 10.6-14.1 19.3v17.7c0 8-6.5 14.5-14.5 14.5h-46.5c-8 0-14.5-6.5-14.5-14.5v-46.5c0.3-28.8 22.4-54.3 50.5-58.3 41.2-5.4 71.7-37.2 71.7-74 0-40.9-37.5-74.9-84.4-74.9-46.8 0-84.4 34-84.4 75.1 0 7.6-6.4 13.7-14.3 13.7h-47.1c-7.9 0-14.3-6-14.3-13.8 0-83.5 72.9-150.8 162.2-149.8 86.3 1.2 156.7 67.1 157.8 147.8 1 65.2-43.2 122.8-108.1 143.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-help-filled.svg
// module id = 1698
// module chunks = 137